<template>
  <div class="my-message all-order-content">
    <div class="breadcrumb" style="margin-bottom: 20px;">首页banner</div>
    <div class="right-content">
      <el-form ref="bannerForm" label-width="160px" :model="bannerForm" :rules="rules" class="demo-form-inline">
        <el-form-item label="上传banner图片：" prop="bannerUrl">
          <el-upload :class="{ hide_uploadbtn: bannerForm.bannerUrl.length > 0 }" action="#" list-type="picture-card" accept='image/jpeg' :on-preview="showAppImagePreview('ban')"
            :on-remove="(e) => removeAppImage(e, 'ban')" :file-list="bannerForm.bannerUrl" :http-request="(e) => uploadAppImage(e, 'ban')" :multiple="false" :limit="1">
            <i class="el-icon-plus"></i>
          </el-upload>
          <p style="color: #999;line-height: 22px;">仅可上传一张图片</p>
        </el-form-item>
        <el-form-item label="上传广告详情：" prop="detailsUrl">
          <el-upload action="#" list-type="picture-card" accept='image/jpeg' :on-preview="showAppImagePreview('banDetail')" :on-remove="(e) => removeAppImage(e, 'banDetail')"
            :file-list="bannerForm.detailsUrl" :http-request="(e) => uploadAppImage(e, 'banDetail')" :multiple="true">
            <i class="el-icon-plus"></i>
          </el-upload>
          <p style="color: #999;line-height: 22px;">广告banner请上传广告详情页，可批量选择多张照片，点banner有详情进详情，没详情有产品进产品，都没有不跳转</p>
        </el-form-item>
        <el-form-item label="选择类型：" prop="relationId">
          <div style="display: flex;">
            <el-select v-model="bannerForm.type" placeholder="请选择类型" clearable @change="tableDataList = [], bannerForm.associationId = '', bannerForm.associationName = ''">
              <el-option label="类" value="CATEGORY"></el-option>
              <el-option label="产品" value="SPU"></el-option>
              <el-option label="sku" value="SKU"></el-option>
            </el-select>
            <el-select style="width: 200px;margin-left: 20px;" clearable v-model="bannerForm.associationName" :filter-method="filterMethod" filterable placeholder="请输入产品类/产品名称/产品sku关键词搜索"
              @change="handleChange">
              <el-option v-for="item in tableDataList" :key="item.id" :label="item.name" :value="item" :value-key="item.id"></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBanner" round>确 定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import uploadWebImg from '@/utils/uploadWebImg'
import { spuList, appBannerSave, updateBannerById, spuProperty, queryAllSubs, getRelatesInfo, getBannerInfoById } from '@/api/pms'
import { resolve } from 'path'
export default {
  name: 'banner-detail',
  data () {
    return {
      bannerForm: {
        type: '',
        associationId: '',
        associationName: '',
        bannerUrl: [],
        detailsUrl: []
      },
      tableDataList: []
    }
  },
  async created () {
    if (this.$checkAwsSdk('product')) {
      this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    }
    if (this.$route.query.bannerDetail) {
      this.bannerForm = this.$route.query.bannerDetail
    }
    this.type = this.$route.query.type
    if (this.$route.query.id) {
      await this.getBannerDetail(this.$route.query.id)
    }
    if (this.$hasPermission('pms:admin:property:list')) {
      // 获取产品性质
      // this.getProNature()
    }
  },
  methods: {
    // 搜索产品
    filterMethod (val) {
      if (val.trim()) {
        let param = {
          name: val,
          storeId: process.env.NODE_ENV === 'production' ? 191803 : 190086,
          type: this.bannerForm.type,
          isZeroPurchase: false
        }
        getRelatesInfo(param).then(res => {
          if (res.data.success) {
            this.tableDataList = res.data.data
          }
        })
      }
    },
    // 选择产品
    handleChange (val) {
      this.bannerForm.associationId = val.id
      this.bannerForm.associationName = val.name
    },
    async getBannerDetail (bannerId) {
      await getBannerInfoById(bannerId).then(res => {
        if (res.data.success) {
          this.bannerForm = res.data.data
          this.bannerForm.bannerUrl = res.data.data.bannerUrl ? [{ url: res.data.data.bannerUrl }] : []
          if (res.data.data.detailsUrl) {
            this.bannerForm.detailsUrl = res.data.data.detailsUrl.split(',').map(a => {
              return {
                url: a
              }
            })
          } else {
            this.bannerForm.detailsUrl = []
          }
          console.log(' this.bannerForm.', this.bannerForm)
        }
      })
    },
    // 上传产品phone端详情图片
    uploadPhoneDetailImg (e) {
      if (e.file.type !== 'image/jpeg' && e.file.type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (e.file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        // 获取富文本组件实例
        let quill = this.$refs.phoneQuillEditor.quill
        // 如果上传成功
        if (res) {
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'image', res)
          quill.setSelection(length + 1)
        } else {
          this.$message.error('图片插入失败')
        }
      })
    },
    removeAppImage (val, type) {
      console.log('removeAppImage', val)
      if (type == 'ban') {
        this.bannerForm.bannerUrl = []
      } else if (type == 'banDetail') {
        // this.bannerForm.bannerUrl = []
        this.bannerForm.detailsUrl = this.bannerForm.detailsUrl.filter(a => a.uid !== val.uid)
        console.log('bannerForm.detailsUrl', this.bannerForm.detailsUrl)
      }
      // this.bannerForm.bannerUrl = ''
    },
    showAppImagePreview (type) {
      this.showImgPreview = true
      this.previewImage = this.bannerForm.bannerUrl
    },
    uploadAppImage (e, type) {
      console.log('e', e)
      if (e.file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
      }
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        if (res) {
          if (type == 'ban') {
            this.bannerForm.bannerUrl.push({ url: res })
          }
          if (type == 'banDetail') {
            console.log('res', res)
            this.bannerForm.detailsUrl.push({ url: res })
          }
          this.showPcImage = false
          this.$refs.bannerForm.validateField('bannerUrl')
        } else {
          this.$message.error('图片上传失败')
        }
      })
    },
    saveBanner () {
      console.log(this.bannerForm.bannerUrl)
      if (!this.bannerForm.associationName) {
        this.bannerForm.associationId = ''
      }
      if (this.bannerForm.bannerUrl.length < 1) {
        this.$message.error('请上传banner图片！')
        return
      }
      let detailsUrl = this.bannerForm.detailsUrl?.map(a => {
        return a.url
      })
      this.bannerForm.detailsUrl = detailsUrl.toString()
      this.bannerForm.bannerUrl = this.bannerForm.bannerUrl[0]?.url || ''
      if (!this.bannerForm.id) {
        appBannerSave(this.bannerForm).then(res => {
          if (res.data.success) {
            this.$notify({
              title: '成功',
              message: '保存成功',
              type: 'success'
            })
            this.$router.go(-1)
          }
        }
        )
      } else {
        delete this.bannerForm.updateTime
        delete this.bannerForm.createTime
        updateBannerById(this.bannerForm).then(res => {
          if (res.data.success) {
            if (res.data.success) {
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success'
              })
              this.$router.go(-1)
            }
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
@deep: ~">>>";

/deep/ .el-upload-list__item-thumbnail {
  // width: auto !important;
  object-fit: scale-down;
}

@{deep} .pc_detail {
  width: 100%;

  img {
    width: 100%;
  }
}

@{deep} .hide_uploadbtn .el-upload--picture-card {
  display: none;
  /* 上传按钮隐藏 */
}

// @{deep} .ql-container .ql-snow {
//   height: 500px;
// }
@{deep} .ql-container {
  height: auto !important;
}

.quill-editor {
  width: 70%;

  @{deep} .ql-editor {
    min-height: 400px;
  }

  @{deep} .ql-toolbar {
    .ql-picker-label {
      height: auto;
    }

    .ql-picker.ql-expanded .ql-picker-options {
      top: auto;
    }
  }
}

@{deep} .el-cascader {
  line-height: 0;
}
</style>
